import React from "react";
import "./ListLabel.scss";

export default function ListLabel(props: { children: string }) {
  return <div className="ListLabel">{props.children}</div>;
}
